// Betriebsebene im Browser (V-1015, Teil von V-0972 P1f): Beta läuft auf einer eigenen Adresse.
// Die Adresse entscheidet nur, WELCHER Code antwortet — die Berechtigung sitzt im Server
// (EbenenRiegelSubscriber). Hier steht nur die Umleitung und die Kennzeichnung.

export const BETA_HOST_PREFIX = 'erp-beta.';
export const BETA_URL = 'https://erp-beta.bispicy.com';

/** Läuft die SPA gerade auf der Beta-Adresse (erp-beta.*)? */
export function istBetaHost(hostname: string = window.location.hostname): boolean {
  return hostname.toLowerCase().startsWith(BETA_HOST_PREFIX);
}

/** Nur eigene Adressen sind ein zulässiges Umleitungsziel (kein offener Redirect). */
export function istErlaubtesZiel(ziel: unknown): ziel is string {
  if (typeof ziel !== 'string') return false;
  try {
    const url = new URL(ziel);
    const host = url.hostname.toLowerCase();
    return url.protocol === 'https:' && (host === 'bispicy.com' || host.endsWith('.bispicy.com'));
  } catch {
    return false;
  }
}

/** Ist dies eine bispicy.com-Adresse (Schutz: lokale Entwicklung und Fremdhosts nie umleiten)? */
export function istBispicyHost(hostname: string = window.location.hostname): boolean {
  const host = hostname.toLowerCase();
  return host === 'bispicy.com' || host.endsWith('.bispicy.com');
}

/**
 * Antwort 403 `falsche_ebene`: der Mandant arbeitet auf der anderen Ebene → auf `ziel` umleiten.
 * Gibt true zurück, wenn umgeleitet wird. Schleifenschutz: gleiche Herkunft wird nie angesprungen.
 */
export function leiteBeiFalscherEbeneUm(ziel: unknown): boolean {
  if (!istErlaubtesZiel(ziel)) return false;
  if (new URL(ziel).origin === window.location.origin) return false;
  window.location.assign(ziel);
  return true;
}
